/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { TestPanePredictionStore } from 'src/luis/types/stores/testPane/TestPanePredictionStore';
import { TestPanePredictionStoreHouse } from 'src/luis/types/stores/testPane/TestPanePredictionStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating a test pane prediction store house
 */
export const createTestPanePredictionStoreHouse = (): TestPanePredictionStoreHouse => {
    const resourceStoreHouse = createResourceStoreHouse<TestPanePredictionStore>();

    const testPanePredictionStoreHouse: SubtractStore<TestPanePredictionStoreHouse, ResourceStoreHouse<TestPanePredictionStore>> = {
        /**
         * Find the prediction by the utterance text.
         */
        findByText(text) {
            return this.items.find(i => i.mainUtterance.utterance.text.toLocaleLowerCase() === text.toLocaleLowerCase());
        }
    };

    return extendObservable(
        resourceStoreHouse,
        testPanePredictionStoreHouse,
        {
            findByText: action
        },
        { deep: false }
    );
};
